<template>
  <div
    @keydown="handleKeyDown"
    @click="handleClick"
  >
    <div :ref="controlRef">
      <DxHtmlEditor
        :ref="controlFocusRef"
        v-model="internalText"
        :mentions="mentions"
        class="ms-dx-html-editor"
        value-type="html"
        :disabled="disabled"
        :style="{
          'max-height': isNaN(maxHeight) ? maxHeight : maxHeight + 'px',
          'min-height': isNaN(minHeight) ? minHeight : minHeight + 'px',
          height: isNaN(height) ? height : height + 'px',
          'border-color': errorProvider.isValid ? '#DE3618 !important' : '#ddd'
        }"
        :on-focus-in="onFocusIn"
        :on-focus-out="onFocusOut"
        :placeholder="placeholder"
        @value-changed="onValueChanged"
        @initialized="onInitialized"
        @option-changed="onOptionChanged"
      >
        <template #list-mention="data">
          <slot
            name="mention-item"
            :data="data"
          />
        </template>
        <DxMediaResizing :enabled="true" />
        <DxToolbar
          v-if="!disabled"
          :multiline="isMultiline"
        >
          <DxItem
            v-if="showToolBarDefault"
            format-name="bold"
          />
          <DxItem
            v-if="showToolBarDefault"
            format-name="underline"
          />
          <DxItem
            v-if="showToolBarDefault"
            format-name="italic"
          />
          <DxItem
            v-if="showToolBarDefault"
            format-name="separator"
          />
          <DxItem
            v-if="showToolBarDefault && showAlign"
            format-name="alignLeft"
          />
          <DxItem
            v-if="showToolBarDefault && showAlign"
            format-name="alignCenter"
          />
          <DxItem
            v-if="showToolBarDefault && showAlign"
            format-name="alignRight"
          />
          <DxItem
            v-if="showToolBarDefault && showAlignJustify"
            format-name="alignJustify"
          />
          <DxItem
            v-if="showToolBarDefault"
            format-name="separator"
          />
          <DxItem
            v-if="formatSize"
            :format-values="sizeValues"
            format-name="size"
          />
          <DxItem
            v-if="formatFont"
            :format-values="fontValues"
            format-name="font"
          />
          <DxItem
            v-if="showToolBarDefault"
            format-name="separator"
          />
          <DxItem
            v-for="(item, index) in customFormat"
            :key="index"
            :name="item"
          />
          <DxItem
            v-if="formatUndo"
            format-name="undo"
          />
          <DxItem
            v-if="formatRedo"
            format-name="redo"
          />
        </DxToolbar>
      </DxHtmlEditor>
    </div>
    <ms-tooltip
      v-if="errorProvider.isValid"
      class="icon-input-tree-select icon-error-editor"
      :show-tooltips="false"
    >
      <div>
        <div class="mi mi-20 mi-icon-error mr-2" />
      </div>
    </ms-tooltip>
    <p :class="{ 'text-error': errorProvider.isValid }">
      {{ errorProvider.message }}
    </p>
  </div>
</template>
<script>
import {
  DxHtmlEditor,
  DxToolbar,
  DxMediaResizing,
  DxItem
} from "devextreme-vue/html-editor";
import msBaseComponent from "@/components/controls/msbase/msBaseComponent.vue";
import { MsControlRef,MsControlFocusRef } from "@/models/enums/MsControlRefConst.js";
export default {
  name: "MsHtmlEditor",
  components: {
    DxHtmlEditor,
    DxMediaResizing,
    DxToolbar,
    DxItem
  },
  extends: msBaseComponent,
  props: {
    autoFocus: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    //Thuộc tính ref của editor
    refName: {
      type: String,
      default: null,
    },
    showAlignJustify: {
      type: Boolean,
      default: true,
    },
    showAlign: {
      type: Boolean,
      default: true,
    },
    value: {
      type: String,
      default: ''
    },
    height: {
      type: [Number, String],
      default: "auto",
    },
    maxHeight: {
      type: [Number, String],
      default: "auto",
    },
    minHeight: {
      type: [Number, String],
      default: "auto",
    },
    // có bật thuộc tính Undo không
    formatUndo: {
      type: Boolean,
      default: false,
    },
    // có bật thuộc tính redo không
    formatRedo: {
      type: Boolean,
      default: false,
    },
    //Có bật thuộc tính chọn size không
    formatSize: {
      type: [Boolean, String],
      default: false,
    },
    //Có bật thuộc tính chọn font không
    formatFont: {
      type: [Boolean, String],
      default: false,
    },
    //Truyền danh sách thuộc tính muốn bật thêm các loại format có như dataFormat
    customFormat: {
      type: Array,
      default: () => [],
    },
    //Có Hiển thị nhiều dòng không
    isMultiline: {
      type: [Boolean, String],
      default: true,
    },
    //Danh sách dữ liệu của popup mention
    dataMentions: {
      type: [Array, Object],
      default: () => [],
    },
    //mảng những trường cần search ["field1","field2"]
    searchExpr: {
      type: Array,
      default: () => [],
    },
    //Trường hiển thị trên popup mention
    displayExpr: {
      type: String,
      default: "",
    },
    //giá trị được lấy khi select item trên popup mention
    valueExpr: {
      type: [String, Function],
      default: function () {
        return "";
      },
    },
    //Ký tự để mở popup mention
    marker: {
      type: String,
      default: "@",
    },
    templateMetion: {
      type: Function,
    },
    searchTimeout: {
      type: Number,
      default: 200,
    },
    //Tự động show những option mặc định trên toolbar
    showToolBarDefault: {
      type: [Boolean, String],
      default: true,
    },
    // Có cho phép xóa hay không
    isAllowDelete: {
      type: Boolean,
      default: true,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      mentions: [
        {
          dataSource: this.dataMentions,
          searchExpr: this.searchExpr,
          displayExpr: this.displayExpr,
          valueExpr: this.valueExpr,
          marker: this.marker,
          itemTemplate: "list-mention",
          searchTimeout: 100,
          template: this.templateMetion,
          controlRef: MsControlRef.MsTextarea,
        },
      ],
      sizeValues: ["8px", "10px", "12px", "14px", "18px", "24px", "36px"],
      fontValues: [
        "Arial",
        "Courier New",
        "Georgia",
        "Impact",
        "Lucida Console",
        "Tahoma",
        "Times New Roman",
        "Verdana",
        "Roboto",
      ],
      headerValues: [false, 1, 2, 3, 4, 5],
      dataFormat: [
        "strike",
        "orderedList",
        "bulletList",
        "color",
        "background",
        "link",
        "image",
        "clear",
        "codeBlock",
        "blockquote",
        "insertTable",
        "deleteTable",
        "insertRowAbove",
        "insertRowBelow",
        "deleteRow",
        "insertColumnLeft",
        "insertColumnRight",
        "deleteColumn",
      ],
      textHtmlX: this.value, // Khi không cho phép xóa dùng gán lại giá trị
      variables: ["FirstName", "LastName", "Company"],
      escapeCharacters: ["#"],
      internalText: this.value,
      controlRef: MsControlRef.MsHtmlEditor,
      controlFocusRef: MsControlFocusRef.MsHtmlEditor
    };
  },
  watch: {
    value() {
       this.internalText = this.value;
    }
  },
  methods: {
      /**
     * @override
     */
    focusError(){
      this.$refs[this.controlFocusRef].instance.focus();
    },

    /**
    Bắt sự thay đổi của nội dung html editor
    Created by tcduong 15.4.2021
     */
    onOptionChanged() {
      setTimeout(() => {
        $(".no-text-data-suggestlist").remove();
        $(".dx-empty-message").after(
          `<div class='no-text-data-suggestlist'>${this.$t(
            "i18nCommon.NoData"
          )}</div>`
        );
      }, 300);
    },
    onFocusOut(e) {
      this.$emit("onFocusOut", e);
    },
    onFocusIn(e) {
      this.$emit("onFocusIn", e);
    },
    onInitialized(e) {
      const htmlEditor = e.component;
      var Mention = htmlEditor.get("modules/mentions");
      var ALLOWED_PREFIX_CHARS = [" ", "\n", "{", "["];
      class myMent extends Mention {
        _isMarkerPartOfText(retain) {
          if (
            !retain ||
            ALLOWED_PREFIX_CHARS.indexOf(
              this._getCharByIndex(retain - 1) !== -1
            )
          ) {
            return false;
          }
          return true;
        }
      }
      htmlEditor.register({ "modules/mentions": myMent });
      if (this.autoFocus) {
        setTimeout(() => {
          this.$refs[this.refName].instance.focus();
        }, 0);
      }
    },
    /**
     * Bắt sự thay đổi của nội dung editor
     * created by tcduong 5.4.2021
     */
    onValueChanged(val) { 
      const me = this;
      if(val.value == undefined || val.value == null) val.value = ''
      // val.value = me.handleValueContent(val.value);
      let listImg = val.value.match(/<img .*?>/g);
      if(listImg){
        for(let i = 0; i < listImg.length; i++){
          const img = listImg[i];
          let container = document.createElement('div');
          container.innerHTML = img;
          if(!container.firstElementChild.getAttribute('isSystem')) val.value = val.value.replaceAll(img,'');
          if(val.value == '<p></p>') val.value = ''
        }
      }
      if(val.value !== val.previousValue) me.internalText = val.value;
      // if(val.value.match(/<img .*?>/g)) {
      //   me.$nextTick(() => {
      //     me.internalText = val.previousValue
      //   })
      // }
      me.validate(me.internalText);
      me.$emit("input", val.value);
      me.$emit("onValueChanged", val);
    },

    /**
     * Xử lý nội dung kiến nghị (Xóa style nền, font chữ)
     * NVHa1 05/04/2022
     */
    handleValueContent(value){
      const me = this;
      var container = document.createElement('div');

      container.innerHTML = value;
      $(container).find('span').removeAttr('style');
      return container.innerHTML;
    },

    /**
     * Sự kiện khi click vào editor và trả về giá trị của ref
     * Created by tcduong 29.3.2021
     */
    handleClick(e) {
      this.$emit("handleClick", this.$refs[this.refName]);
      /* Gán giá trị cho textHtmlX */
      if (!this.isAllowDelete) {
        this.textHtmlX = this.internalText;
      }
    },
    /**
     * bắn event key down
     * Created by CVCUONG1 - 25/3/2021
     */
    handleKeyDown(e) {
      this.$emit("keyDown", e);
      event.stopPropagation();
      if (e.key === "Escape") {
        this.$emit("keyEscape");
      } else if (e.key === "Enter") {
        if (e.shiftKey) {
        } else {
          this.$emit("keyEnter");
        }
      }
      // Gán lại giá trị khi không cho phép xóa
      if (!this.isAllowDelete) {
        this.internalText = this.textHtmlX;
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/controls/_variables.scss";
.dx-htmleditor-content.ql-blank::before {
  top: 15px !important;
  left: 14px !important;
  color: var(--text-placeholder-color) !important;
  font-style: normal !important;
}

.dx-htmleditor-content img {
  vertical-align: middle;
  padding-right: 10px;
}

// .dx-htmleditor-content table {
//   width: 50%;
// }

.options {
  padding: 20px;
  background-color: rgba(191, 191, 191, 0.15);
  margin-top: 20px;
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 10px;
}
.dx-htmleditor {
  border-radius: 4px;
  .dx-htmleditor-toolbar-wrapper:first-child {
    border-bottom: none;
  }
  .dx-htmleditor-toolbar {
    border-radius: 4px;
    background-color: #f3f5ff;
  }

  
}
.dx-htmleditor.dx-state-focused{
  border-color: var(--input-hover-border-color) !important;
}
.ql-editor.dx-htmleditor-content{
  *{
    color: var(--text-primary-color);
    line-height: 25px;
  }
  a{
    color: #0075c0;
  }
}
.ms-dx-html-editor {
  border-radius: 4px;
  .dx-list-item {
    display: flex !important;
    align-items: center !important;
    height: auto;
    .dx-list-item-content {
      padding: 0px !important;
    }
  }
}
/**
  * Hàm sửa địa chỉ email
  * created NVDINH 22/3/2021
**/
.ms-dx-html-editor u {
  text-decoration: underline;
}

// custom style thẻ tag
.dx-variable {
  margin: 0 2px;
}
.dx-htmleditor-content .dx-variable > span {
  padding: 1px 0;
  border-radius: 2px;
  background-color: #ddd;
  color: #333;
}

//Css popup suggestion
.dx-popup-wrapper.dx-suggestion-list-wrapper {
  .dx-empty-message {
    display: none;
  }
  .no-text-data-suggestlist {
    text-align: center;
    padding: 8px;
    height: 20px;
  }
}
.dx-overlay-content {
  min-width: 150px;
}
.dx-suggestion-list-wrapper.dx-popup-wrapper .dx-overlay-content {
  max-height: 300px !important;
  .dx-popup-content {
    max-height: 300px !important;
  }
}
.dx-list-item.dx-state-focused {
  background-color: var(--primary-bg) !important;
  color: var(--primary) !important;
}
</style>
